export default __webpack_public_path__ + "static/media/write-article.36170c84.png";